import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FILE_SCOPE_POST } from '../../../../../constants/file'
import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../../../constants/qa'
import { useReadMore } from '../../../../../hooks'
import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import { FilesContentGallery } from '../../../../FilesContentGallery'
import {
  Rating,
  RATING_ITEM_SIZE,
  RATING_TYPE_LABEL_KEY,
} from '../../../../Rating'
import Text from '../../../../Text'
import { getRatingCardRows } from '../RequestProfileTabRatingCard.utils'

import * as styles from './RequestProfileTabRatingCardBody.module.css'

function RequestProfileTabRatingCardBody({ value = EMPTY_OBJECT }) {
  const { t } = useTranslation()

  const ratingRows = getRatingCardRows(value)

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({ textData: value.text })

  return (
    <>
      <div className={styles.fields}>
        <div className={styles.ratings}>
          {ratingRows.map(({ type, value: ratingValue }) => (
            <div className={styles.ratingRow} key={type}>
              <Text isSecondary className={styles.ratingLabel}>
                {t(RATING_TYPE_LABEL_KEY[type])}
              </Text>
              <Rating itemSize={RATING_ITEM_SIZE.size24} rating={ratingValue} />
            </div>
          ))}
        </div>
        {value.text ? (
          <div className={styles.commentSection}>
            <Text className={styles.comment} ref={textRef}>
              {value.text}
            </Text>
            {showReadMore ? (
              <Button.Contained
                isGrey
                height={BUTTON_HEIGHT_24}
                qaName={
                  isReadMore
                    ? QA_NAME_SHOW_LESS_BUTTON
                    : QA_NAME_SHOW_MORE_BUTTON
                }
                text={t(
                  isReadMore
                    ? 'Notification.CommonReadLessBtnKey'
                    : 'Notification.CommonReadMoreBtnKey'
                )}
                onClick={handleClickReadMore}
              />
            ) : null}
          </div>
        ) : null}
      </div>
      {value.files?.length > 0 ? (
        <FilesContentGallery
          files={value.files}
          filesListClassName={styles.galleryStrip}
          scope={FILE_SCOPE_POST}
        />
      ) : null}
    </>
  )
}

export default RequestProfileTabRatingCardBody
